export enum EnergyAgreementSortFields {
  ID = "ID",
  NAME = "NAME",
  REGISTRY_NUMBER = "REGISTRY_NUMBER"
}

export interface CustomerEnergyAgreement {
  id: number;
  name: string;
  startDate: string;
  endDate?: string;
  customer: {
    id: number;
    name: string;
    registryNumber: string;
    groupId: string;
  }
}

export interface EnergyAgreement {
  id: number;
  energyPackageId: number;
  customerId: number;
  startDate: string;
  endDate?: string;
  isTerminated: boolean;
}

export interface CustomerEnergyAgreementData {
  agreements: EnergyAgreement[];
  canSwitchPackage: boolean;
}